/**
 * Brera · Confianza (snippets/trust.liquid: Opinión destacada y Logos de prensa)
 * Rotador para "Una opinión grande" (varias opiniones) y logos "Con frase":
 * [data-trust-rotator] con [data-trust-slide], [data-trust-go="i"] (puntos o logos), [data-trust-prev|next].
 * Cambia solo cada data-autoplay segundos (0 = no), se pausa al pasar el mouse o con el foco dentro.
 * En el editor salta a la opinión o logo seleccionado.
 */
(() => {
  if (window.BreraTrust) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initRotator = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const slides = [...root.querySelectorAll('[data-trust-slide]')];
    const gos = [...root.querySelectorAll('[data-trust-go]')];
    if (slides.length < 2) return;
    let index = 0;
    let timer = null;
    let paused = false;
    const seconds = Number(root.dataset.autoplay || 0);

    const show = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, j) => {
        const on = j === index;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });
      gos.forEach((g) => {
        const on = Number(g.dataset.trustGo) === index;
        g.classList.toggle('is-active', on);
        if (on) g.setAttribute('aria-current', 'true');
        else g.removeAttribute('aria-current');
      });
    };

    const stop = () => {
      clearInterval(timer);
      timer = null;
    };
    const start = () => {
      stop();
      if (!seconds || reduce || paused) return;
      timer = setInterval(() => show(index + 1), seconds * 1000);
    };

    gos.forEach((g) => g.addEventListener('click', () => { show(Number(g.dataset.trustGo)); start(); }));
    const prev = root.querySelector('[data-trust-prev]');
    const next = root.querySelector('[data-trust-next]');
    if (prev) prev.addEventListener('click', () => { show(index - 1); start(); });
    if (next) next.addEventListener('click', () => { show(index + 1); start(); });

    // Deslizar con el dedo
    let x0 = null;
    root.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) < 40) return;
      show(index + (dx < 0 ? 1 : -1));
      start();
    });

    const pause = () => { paused = true; stop(); };
    const resume = () => { paused = false; start(); };
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', resume);

    root.trustShow = (i) => { show(i); pause(); };
    root.trustIndexOf = (el) => {
      const s = slides.indexOf(el);
      if (s > -1) return s;
      const g = el.querySelector && el.querySelector('[data-trust-go]');
      return g ? Number(g.dataset.trustGo) : -1;
    };
    start();
  };

  const init = (scope) => scope.querySelectorAll('[data-trust-rotator]').forEach(initRotator);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);

  // Editor del tema
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const root = e.target.closest && e.target.closest('[data-trust-rotator]');
    if (!root || !root.trustShow) return;
    const i = root.trustIndexOf(e.target);
    if (i > -1) root.trustShow(i);
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    const root = e.target.closest && e.target.closest('[data-trust-rotator]');
    if (root) root.dispatchEvent(new Event('mouseleave'));
  });

  window.BreraTrust = { init };
})();
